// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2RJtg","inputWrap":"styles_inputWrap__2M6Fv","input":"styles_input__3ECMj"};